export default {
  common: {
    live: 'EN VIVO',
    saveClose: 'Guardar y Cerrar',
    pressEnterToReturn: 'Presiona Enter o Retroceso para volver',
  },
  video: {
    pressFor: 'PRESIONA PARA {label}',
    unavailable: 'VIDEO NO DISPONIBLE',
    networkError: 'RED TEMPORALMENTE NO DISPONIBLE',
    networkErrorDesc:
      'Gracias por su paciencia mientras trabajamos para que todo funcione de nuevo.',
  },
  aw: {
    pressFor: 'Presiona para {label}',
  },
  menu: {
    settings: 'CONFIGURACIÓN',
    manageLocations: 'Administrar Ubicaciones',
    privacyPolicy: 'Política de Privacidad',
    termsOfUse: 'Términos de Uso',
    mapSettings: 'Configuración de Mapa',
    rotateLocations: 'Rotar Ubicaciones',
    hourly: 'Por Hora',
    daily: 'Diario',
    maps: 'Mapas',
    pressToExit: 'PRESIONA PARA SALIR',
  },
  weather: {
    currentWeather: 'CLIMA ACTUAL',
    hourly: 'POR HORA',
    currentConditions: 'CONDICIONES ACTUALES',
    lookingAhead: 'Vista General',
    minutecastError: 'MINUTECAST TEMPORALMENTE NO DISPONIBLE',
    minutecastErrorDesc:
      'Gracias por su paciencia mientras trabajamos para que todo funcione de nuevo',
    minutecastTitle: 'MINUTECAST™',
    today: 'Hoy',
    tonight: 'Esta Noche',
    night: 'Noche',
    hi: 'Máx',
    lo: 'Mín',
    mapError: 'MAPA TEMPORALMENTE NO DISPONIBLE',
    mapErrorDesc: 'Gracias por su paciencia mientras trabajamos para que todo funcione de nuevo.',
    conditions: {
      dew_point: 'PUNTO DE ROCÍO',
      humidity: 'HUMEDAD',
      wind: 'VIENTO',
      gusts: 'RÁFAGAS',
      pressure: 'PRESIÓN',
      uv_index: 'ÍNDICE UV',
      visibility: 'VISIBILIDAD',
    },
    units: {
      in: 'pulgadas',
    },
  },
  location: {
    notFound: 'No se puede encontrar la ubicación',
  },
  home: {
    lifeSaving: 'SALVAVIDAS',
    superiorAccuracy: 'PRECISIÓN SUPERIOR',
    protection: 'PROTECCIÓN',
    searchPrompt: 'Busca tu ubicación',
  },
  search: {
    enterZipCode: 'Ingrese Código Postal',
    search: 'Buscar',
  },
  settings: {
    radar: 'Radar',
    satellite: 'Satélite',
    precipitation: 'Precipitación',
    rotation: 'Rotación',
    rotate: 'Rotar',
    duration: 'Duración',
    seconds: 'segundos',
    minutes: 'minutos',
  },
  loading: {
    title: 'Cargando',
    subtitleMap: 'Gracias por su paciencia,\nabriendo el mapa en pantalla completa',
    subtitleDefault: 'Gracias por su paciencia,\nabriendo en pantalla completa',
    unableToLoad: 'No se puede cargar',
    checkConnection: 'Por favor revise su conexión\ne intente de nuevo',
    lastModified: 'ÚLTIMA MODIFICACIÓN',
  },
  maps: {
    types: {
      radar: 'Radar',
      satellite: 'Satélite',
      standardSatellite: 'Satélite Estándar',
      futureRadar: 'Radar Futuro',
      precipitation: 'Precipitación',
      watchesAndWarnings: 'Vigilancias y Advertencias',
      tropical: 'Tropical',
      temperatureContour: 'Contorno de Temperatura',
      visibleSatellite: 'Satélite Visible',
      waterVapor: 'Vapor de Agua',
    },
    legend: {
      rain: 'Lluvia',
      thunderstorm: 'Tormenta',
      snow: 'Nieve',
      ice: 'Hielo',
      mix: 'Mezcla',
      low: 'Bajo',
      high: 'Alto',
    },
  },
  legal: {
    spanishUnavailable:
      'Esta página está disponible únicamente en inglés en este momento. Para la versión oficial, visite el sitio web de AccuWeather.',
    visitOfficialPage: 'Visitar página oficial',
  },
}
